import formatReleaseLine from '@/renderer/utils/formatReleaseLine';

const Release = ({ release }: { release: API.Release }) => {
  const { result } = release;
  const formattedRelease = formatReleaseLine(release, false, true);

  let resultColor = 'bg-zinc-400';

  if (result === 'win') {
    resultColor = 'bg-emerald-400';
  } else if (result === 'loss') {
    resultColor = 'bg-rose-600';
  } else if (result === 'pending') {
    resultColor = 'bg-amber-300';
  }

  return (
    <div className="my-2 w-full rounded bg-zinc-900/5 p-4 shadow dark:bg-white/10 dark:shadow-inner dark:shadow-white/5">
      <div className="text-xs text-zinc-600 dark:text-zinc-400">{release.sport.name}</div>
      <div className="text-sm">
        <span className="font-bold">{formattedRelease}</span>{' '}
      </div>
      <hr className="my-2 h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
      <div className="flex">
        <span className="my-auto flex h-2 w-2">
          <span className={`m-auto inline-flex h-2 w-2 rounded-full ${resultColor}`} />
        </span>
        <div className="ml-2 text-xs text-zinc-600 dark:text-zinc-400">
          {result.charAt(0).toUpperCase() + result.slice(1)}
        </div>
      </div>
    </div>
  );
};

export default Release;
